'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body style={{ fontFamily: 'system-ui', padding: 40 }}>
        <h2>Bir hata olustu</h2>
        <pre style={{ background: '#f5f5f5', padding: 16, borderRadius: 8, overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          {error.message}
          {'\n\n'}
          {error.stack}
          {error.digest && `\n\nDigest: ${error.digest}`}
        </pre>
        <button onClick={reset} style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>
          Tekrar Dene
        </button>
      </body>
    </html>
  )
}
